import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ClipboardList, Settings, LogOut, Store, CalendarCheck, Users } from "lucide-react";
import { toast } from "sonner";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
  { to: "/admin/products", label: "Products", icon: Package, testid: "nav-products" },
  { to: "/admin/orders", label: "Orders", icon: ClipboardList, testid: "nav-orders" },
  { to: "/admin/customers", label: "Customers", icon: Users, testid: "nav-customers" },
  { to: "/admin/bookings", label: "Bookings", icon: CalendarCheck, testid: "nav-bookings" },
  { to: "/admin/settings", label: "Settings", icon: Settings, testid: "nav-settings" },
  { to: "/shop", label: "View Shop", icon: Store, testid: "nav-shop" },
];

export default function AdminLayout() {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("al_token");
    toast.success("Signed out");
    navigate("/admin/login");
  };

  const linkClass = ({ isActive }) =>
    `flex items-center justify-center md:justify-start gap-3 px-2 md:px-4 py-3 text-xs tracking-[0.2em] uppercase transition-colors duration-300 ${
      isActive ? "text-[#9E7B3A] border-r-2 border-[#C5A059] bg-[#C5A059]/5" : "text-[#4A4A4A] hover:text-[#9E7B3A]"
    }`;

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex" data-testid="admin-panel">
      <aside className="w-16 md:w-60 flex flex-col border-r border-[#C5A059]/20 bg-white shrink-0 min-h-screen sticky top-0">
        <div className="flex items-center justify-center md:justify-start gap-3 px-2 md:px-5 py-6 border-b border-[#C5A059]/20">
          <img src="/assets/logo.png" alt="AL" className="w-9 h-9 rounded-full" />
          <div className="hidden md:block">
            <p className="font-serif text-sm">Australian Luxe</p>
            <p className="text-[9px] tracking-[0.3em] uppercase text-[#9E7B3A]">Admin</p>
          </div>
        </div>
        <nav className="flex-1 py-6 flex flex-col gap-1">
          {NAV.map(({ to, label, icon: Icon, end, testid }) => (
            <NavLink key={to} to={to} end={end} className={linkClass} data-testid={testid} title={label}>
              <Icon className="w-4 h-4 shrink-0" />
              <span className="hidden md:inline">{label}</span>
            </NavLink>
          ))}
        </nav>
        <button onClick={logout} data-testid="admin-logout-button" title="Sign Out"
          className="flex items-center justify-center md:justify-start gap-3 px-2 md:px-4 py-5 text-xs tracking-[0.2em] uppercase text-[#4A4A4A] hover:text-[#9E7B3A] border-t border-[#C5A059]/20 transition-colors duration-300">
          <LogOut className="w-4 h-4 shrink-0" />
          <span className="hidden md:inline">Sign Out</span>
        </button>
      </aside>

      <div className="flex-1 min-w-0">
        <main className="p-4 md:p-10 max-w-6xl">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
